import { TableDateCell } from '../../Table'

function EmailTableRowDateCreated({ item, ...restProps }) {
  const { created, last_message_created: date, unread } = item

  return (
    <TableDateCell {...restProps} unread={unread} value={date || created} />
  )
}

export default EmailTableRowDateCreated
